import {
  computeIsConfigTable,
  computeTableProvenanceUuid,
} from 'notebook/tables/store/logic/TableContextLogic';
import {createTableModelSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {TableEditableStore, TableEditableVolatileProps} from 'notebook/tables/store/TableStore';

export interface TableContextModel {
  isConfigTable: boolean;
  tableProvenanceUuid: string | null;
}

export function createTableContextSelector(
  volatilePropsSelector: (store: TableEditableStore) => TableEditableVolatileProps
): (store: TableEditableStore) => TableContextModel {
  return createTableModelSelector(
    [
      (store) => volatilePropsSelector(store).table,
      (store) => store.editorContext.isConfig,
      (store) => store.stableProps.fileIsConfig,
      (store) => volatilePropsSelector(store).table.provenanceUuid,
      (store) => store.stableProps.proxyProvenanceUuid,
    ],
    (table, editorContextIsConfig, fileIsConfigProp, tableProvenanceUuid, proxyProvenanceUuid) => ({
      isConfigTable: computeIsConfigTable(table, editorContextIsConfig, fileIsConfigProp),
      tableProvenanceUuid: computeTableProvenanceUuid(tableProvenanceUuid, proxyProvenanceUuid),
    })
  );
}
